module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAAAXNSR0IArs4c6QAAAPlJREFUOE+l079qAkEQx/HvDwMp0/kGqVKmTmFhJ1gICnb2KVIETB2wCKRQECzsrghY2PsMvoRCikBKwSJgGJlwhLsV4dad8tj97Py5kZnNgRZpsQcGMrOvNOf/dlbEDsAS+AH6wFXkI4sitpD05ICZjYAe0AZ2BbQLPJ95pIRlkoY59gr4xaakz/xbDXgEXqpgXmYG/HozU8uMbNHJ8VKZPt4V4BnGRAOoAyVsLOktRsl76b2dhNg38HFBZj7x2xDz8taxmQF3wE2IzST5LxEVZtYBpiG2AWb5BlQFfUt8W+5DrCpw7tzfNLfAdaoEzB3zmh8SMd+a9yM63XYC9Q6dXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home3.png
// module id = EmuO
// module chunks = 20